import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseProfessionsSearch } from "@/features/catalog";
import { ProfessionsPage } from "@/features/catalog/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/catalog/professions")({
  validateSearch: strictSearch(parseProfessionsSearch),
  component: Professions,
});

function Professions() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <ProfessionsPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next })}
      hrefOf={(next) => router.buildLocation({ to: "/catalog/professions", search: next }).href}
    />
  );
}
